import React from "react";

// Components
import { Select } from "antd";
import { Label, RedText, Text } from "../Input/Input.styles";
import { DropdownSelectWrapper } from "./DropdownSelect.styles";

const { Option } = Select;

interface Props {
  options: { value: string; text: string }[];
  value?: string;
  defaultValue?: string;
  handleChange: (value: string) => void;
  style?: object;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  displayOnly?: boolean;
}

const DropdownSelect: React.FC<Props> = ({
  options,
  value,
  defaultValue,
  handleChange,
  style,
  label,
  required,
  disabled,
  displayOnly,
}) => (
  <DropdownSelectWrapper disabled={disabled}>
    {label ? (
      <Label>
        {label}
        {required ? <RedText>*</RedText> : null}
      </Label>
    ) : null}
    {displayOnly ? (
      <Text>{!value ? "-" : value === "base" ? "Base Product" : "Virtual Kit"}</Text>
    ) : (
      <Select disabled={disabled} value={value} style={style} onChange={handleChange} defaultValue={defaultValue}>
        {options.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.text}
          </Option>
        ))}
      </Select>
    )}
  </DropdownSelectWrapper>
);

export default DropdownSelect;
